class FaqTabs {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.currentSection = document.getElementById(
      `shopify-section-${this.sectionId}`
    );
    this.containers = this.currentSection.querySelectorAll('.container');
    this.navItems = this.currentSection.querySelectorAll('.navi div');
    this.buttons = this.currentSection.querySelectorAll(
      'button[id^="toggle-btn-"]'
    );
  }

  init() {
    this.hideAllContainers();
    this.setInitialActiveState();
    this.addEventListeners();
    this.initSwiper();
  }

  initSwiper() {
    if (window.Swiper) {
      new Swiper('.js-faq-slider', {
        spaceBetween: 40,
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: false,
        watchOverflow: true,
        slidesOffsetAfter: 16,
      });
    } else {
      console.warn('Swiper.js is not loaded.');
    }
  }

  hideAllContainers() {
    this.containers.forEach((container) => {
      container.classList.remove('active');
    });
  }

  toggleContainer(index) {
    this.hideAllContainers();
    const targetContainer = this.containers[index];
    targetContainer.classList.add('active');
    this.setNavItemActiveState(index);
  }

  setInitialActiveState() {
    if (this.containers.length > 0 && this.navItems.length > 0) {
      const firstContainer = this.containers[0];
      firstContainer.classList.add('active');
      const firstNavItem = this.navItems[0];
      firstNavItem.classList.add('active');
    }
  }

  addEventListeners() {
    this.navItems.forEach((navItem, index) => {
      navItem.addEventListener('click', () => this.toggleContainer(index));
    });

    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => this.toggleAccordion(event));
    });
  }

  setNavItemActiveState(index) {
    this.navItems.forEach((navItem, idx) => {
      navItem.classList.remove('active');
      if (idx === index) {
        navItem.classList.add('active');
      }
    });
  }

  toggleAccordion(event) {
    const targetButton = event.target.closest('button');
    const content = targetButton.nextElementSibling;
    const icon = targetButton.querySelector('span[id^="icon-"]');

    if (content.style.maxHeight && content.style.maxHeight !== '0px') {
      content.style.maxHeight = '0';
      icon.classList.remove('rotate-up');
      icon.classList.add('rotate-down');
    } else {
      this.closeAllAccordions();

      content.style.maxHeight = content.scrollHeight + 'px';
      icon.classList.remove('rotate-down');
      icon.classList.add('rotate-up');
    }
  }

  closeAllAccordions() {
    const allContents = this.currentSection.querySelectorAll('.max-h-0');
    allContents.forEach((content) => (content.style.maxHeight = '0'));

    const allIcons = this.currentSection.querySelectorAll('span[id^="icon-"]');
    allIcons.forEach((icon) => {
      icon.classList.remove('rotate-up');
      icon.classList.add('rotate-down');
    });
  }
}

function initializeFaqTabs() {
  const sections = document.querySelectorAll('.faq-tabs');
  sections.forEach((section) => {
    const sectionId = section.getAttribute('data-section-id');
    const faqTabs = new FaqTabs(sectionId);
    faqTabs.init();
  });
}

handlePageLoadEvent(initializeFaqTabs);
handleShopifyEditorEvent(initializeFaqTabs);
